export class BlogPost {
  postId?: number;
  creator: string;
  title: string;
  body: string;
  shortDescription: string;
  photo: string;
  photoData: any;
  dt: Date;
  isActive: boolean;
  categoryId:number;
  categoryName: string;
}
